import { createMuiTheme } from "@material-ui/core/styles";

const Maintheme = createMuiTheme({
  // palette: {
  //   primary: {
  //     light: "#f76969",
  //     main: "#ff9800",
  //     dark: "#de5454",
  //     contrastText: "#fff",
  //   },
  // },
  // status: {
  //   danger: "orange",
  // },
  // palette: {
  //   type: 'dark',
  // },
  
  overrides: {
    // Style sheet name ⚛️
    MuiStepper:{
      horizontal:{
        padding: 0,
      }
    },
    MuiOutlinedInput: {
      // input:{
      // fontSize: "14px",
      // padding: "14px 16px",
      // }
      root: {
        margin: 0,
      },
      inputMarginDense: {
        backgroundColor: "#fafbfc",
        boxShadow: "inset 0 1px 2px rgba(27,31,35,.075)",
        borderRadius: "3px",
        marginLeft: "0",
      },
    },
    MuiAutocomplete: {
      inputRoot:{
        backgroundColor: "#fafbfc",
      },
      input:{
        boxShadow: "none",
      }
      
  },
  MuiFormHelperText:{
    contained:{
      // position: "absolute",
      // transform: "translate(0, 175%)",
    }
  },
    MuiFormControl: {
      marginDense: {
        // marginLeft: ".5rem",
        width: "10rem",
      },
    },
    MuiDialogContent: {
      dividers: {
        padding: "1rem 0",
      },
      // root:{
      //   padding: 0,
      // }
    },
    MuiDialogTitle: {
      root: {
        padding: "1rem 0",
        paddingBottom: ".5rem",
      },
    },
    MuiButton: {
      label: {
        textTransform: "none",
      },
      root: {
        borderRadius: "3px",
      },
    },
    // MuiList: {
    //   root: {
    //     padding: 0,
    //   },
    // },
    // MuiTabs: {
    //   indicator: {
    //     top: 0,
    //   },
    // },
  },

});

export default Maintheme;
